import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../controls/table/table.jsx';
import { actionTanks } from '../../../actions/tanks_actions.jsx';
import { withTranslation } from 'react-i18next';
import * as FileSaver from 'file-saver';
import Loader from '../../controls/loader/loader.jsx';

const Columns = [
    {
        header: "TankStateOperation.tankName",
        name: "tankName"
    },
    {
        header: "TankStateOperation.watterLevelHeight",
        name: "watterLevelHeight",
        dataType: "int"
    },
    {
        header: "TankStateOperation.watterLevelVolume",
        name: "watterLevelVolume",
        dataType: "float"
    },
    {
        header: "TankStateOperation.productLevelHeight",
        name: "productLevelHeight",
        dataType: "int"
    },
    {
        header: "TankStateOperation.productLevelVolume",
        name: "productLevelVolume",
        dataType: "float"
    },
    {
        header: "TankStateOperation.temperature",
        name: "temperature",
        dataType: "float"
    },
    {
        header: "TankStateOperation.density",
        name: "density",
        dataType: "float"
    },
    {
        header: "TankStateOperation.weight",
        name: "weight",
        dataType: "float"
    },
    {
        header: "TankStateOperation.packageTs",
        name: "packageTs",
        dataType: "datetime"
    }
];


class TanksStateOperationsList extends React.Component {

    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.getReport = this.getReport.bind(this);
        this.getFilteredItems = this.getFilteredItems.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData(filter) {
        filter = filter ? filter : this.props.filter;
        this.props.getTanksStateOperations(filter);
    }

    getFilteredItems(modelFilter) {
        let filter = this.props.filter;
        filter.modelFilter = modelFilter;
        this.getData(filter);
    }

    getReport(filter) {
        this.props.getTankStateOperationsReport(filter).then(data => {
            FileSaver.saveAs(data, 'tanks_state_operations.xlsx');
        });

    }

    render() {
        let modelFilter = {
            tankName: {
                name: "tankName",
                type: "string",
                header: this.props.i18n.t('TankStateOperation.Filter.tankName'),
                value: this.props.filter.modelFilter.tankName
            },
            dateTime: {
                name: "dateTime",
                type: "dates",
                dateFrom: {
                    name: "dateFrom",
                    header: this.props.i18n.t("TankStateOperation.Filter.dateFrom"),
                    value: this.props.filter.modelFilter.dateFrom
                },
                dateTo: {
                    name: "dateTo",
                    header: this.props.i18n.t("TankStateOperation.Filter.dateTo"),
                    value: this.props.filter.modelFilter.dateTo
                }
            }
        };

        return (
            <div>
                <Table settings={{
                    columns: Columns,
                    items: this.props.operations,
                    itemsFilter: Object.assign({}, this.props.filter, { filterProps: modelFilter }),
                    isEditable: false,
                    getItemsFunction: this.getData,
                    getReportFunction: this.getReport
                }} />
                {this.props.loading && <Loader />}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        operations: state.tanks.tanksStateOperations,
        filter: state.tanks.tanksStateOperationsFilter,
        loading: state.tanks.loading,
        errors: state.tanks.errors,
        forceReload: state.tanks.forceReload
    };
}

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(actionTanks, dispatch))
    (withTranslation('translantions')(TanksStateOperationsList));